import { useTranslation } from 'react-i18next';
import BoldBlue from './BoldBlue';
import styled from 'styled-components';

const LinkContainer = styled.div`
    display: flex;
    justify-content: space-between;
    align-items: center;
    margin: 2px 0;

    img {
        max-width: 13px;
        max-height: 13px;
        margin: 0;
    }
`;

const PressLinksDisplay = (props) => {

    const { i18n } = useTranslation('common');

    if(!props.pressLinks) return null;

    let decodedLinks = [];
    try {
        decodedLinks = JSON.parse(props.pressLinks);
    } catch (error) {
        console.log(error);
    }

    const link = (url) => {
        if(!url) return null;
        if(url.includes("http")) return url;
        return "https://" + url;
    }

    const removeLink = (index) => {
        decodedLinks.splice(index,1);
        props.setPressLinks(JSON.stringify(decodedLinks));
    }

    return (
        <>
            {decodedLinks && decodedLinks.length > 0 && <>
                <BoldBlue>{i18n.language === "fr" ? "Liens presse" : "Press links"}</BoldBlue><br/>
                {decodedLinks.map((pressLink,i) => {
                    return (
                        <LinkContainer key={i}>
                            <a href={link(pressLink.url)} target="_blank" rel="noreferrer"><BoldBlue style={{display:"inline-block"}}><img alt="" style={{margin:"0 5px 0 0",display:"inline-block"}} src='/img/fleche_bleue.png'/>{pressLink.title}</BoldBlue></a>
                            {props.setPressLinks && <span style={{cursor:"pointer"}} onClick={() => removeLink(i)}><img alt="" src='/img/x_noir.png'/></span>}
                        </LinkContainer>
                    )
                })}
                <br/>
            </>}
            {props.inputName && <input hidden name={props.inputName} readOnly value={props.pressLinks} />}
        </>
    );
};

export default PressLinksDisplay;
